import React from 'react';
// Constants
import { CompanyName } from '../../utils/Constants';
// Components
import Navbar from '../nav/Navbar';

function VideoHeader() {
  return (
    <header className='grid h-full border-b-2 border-solid border-colour7'>
      <div className='grid relative bg-aboutHerophone lg:bg-aboutHero bg-cover bg-no-repeat bg-[center_top_30%] h-full'>

        <div className='hidden lg:grid'>
          <Navbar />
        </div>

       <div className='absolute top-6 left-6 lg:top-16 lg:left-8  font-hello-paris-regular text-6xl tracking-wider'><h1>The Mistress Diva</h1></div>
      </div>
    </header>
  );
}

export default VideoHeader;
